import { Directive, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { FeatureFlag } from '@bn/primitives';

import { MENU_ACCESS } from './menu-access.token';

/**
 *
 * Usage examples:
 *
 * On html elements:
 *
 *    <ng-container *featureFlag="menuItem.featureFlag">
 *
 * Menu item and its children:
 *
 *   {
 *      name: 'Compute',
 *      featureFlag: Features.Compute,
 *      children: [{
 *          name: 'Scripts',
 *          icon: ['fad', 'code'],
 *          route: AppRoutes.Script,
 *          featureFlag: Features.Scripts
 *      }],
 *    }
 *
 */

@Directive({
  selector: '[featureFlag]',
})
export class FeatureFlagDirective {
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly templateRef = inject<TemplateRef<ViewContainerRef>>(TemplateRef);
  private readonly access = inject(MENU_ACCESS, { optional: true });

  @Input()
  public set featureFlag(currentFeatureFlag: FeatureFlag | undefined) {
    if (!currentFeatureFlag || !this.access) {
      this.viewContainer.createEmbeddedView(this.templateRef);

      return;
    }

    this.access.checkFeatureFlag(currentFeatureFlag).subscribe((result) => {
      // NOTE: do this because checkFeatureFlag shouldn't have
      // the first emit from getUserDetails is null
      // clearing the viewContainer assures there are no duplicated components rendered.
      this.viewContainer.clear();

      if (result) this.viewContainer.createEmbeddedView(this.templateRef);
    });
  }
}
